export default {
  reccuring: 'Recurring',
  'group-booking': 'Group Booking',
  'group-booking-disabled-prepayment': 'Group bookings are not available for appointments with a deposit',
  title: 'Recurring Service',
  update: 'Update Recurring',
  save: 'Save',
  reset: 'Reset',
  appointments: 'Appointments',
  'repeat-number-label': 'Number of Appointments',
  'appointments-to-be-added': 'Appointments to be added ({count})',
  repeat: {
    'every-day': 'Daily',
    'every-week': 'Weekly',
    'every-two-weeks': 'Every two weeks',
    'every-three-weeks': 'Every three weeks',
    'every-four-weeks': 'Every four weeks',
    'every-six-weeks': 'Every six weeks',
    'every-month': 'Monthly',
    'custom': 'On selected days',
    'group-booking': 'Group booking',
  },
  headers: {
    'repeat-rules': 'Repeat Rules',
    'end-repeating': 'End Date',
    'repeat-till': 'Repeat till:',
    'group-size': 'Group size',
  },
  'neverending-help': 'If you choose Never, recurring appointments will be created in a series of {hardLimit} appointments at a time. Booksy will create each series of appointments automatically for as far into the future as your Booking Window allows.',
  'neverending-help-2': 'To change your Booking Window, got to Business Profile > Settings > Advanced Options > Booking Settings > Future Booking Window',
  'end-type': {
    'never': 'Never',
    'on-date': 'On selected date',
    'after-n-bookings': 'After selected number of appointments',
  },
  badges: {
    'daily': 'Repeats every day for {number} occurrences,<br/>starting on {start} ending on {end}',
    'daily-neverending': 'Repeats every day,<br/>starting on {start}, never ends',
    'weekly': 'Repeats every week for {number} occurrences,<br/>starting on {start} ending on {end}',
    'weekly-neverending': 'Repeats every week,<br/>starting on {start}, never ends',
    'biweekly': 'Repeats bi-weekly for {number} occurrences,<br/>starting on {start} ending on {end}',
    'biweekly-neverending': 'Repeats every two weeks,<br/>starting on {start}, never ends',
    'three-weeks': 'Repeats every three weeks for {number} occurrences,<br/>starting on {start} ending on {end}',
    'three-weeks-neverending': 'Repeats every three weeks,<br/>starting on {start}, never ends',
    'four-weeks': 'Repeats every four weeks for {number} occurrences,<br/>starting on {start} ending on {end}',
    'four-weeks-neverending': 'Repeats every four weeks,<br/>starting on {start}, never ends',
    'six-weeks': 'Repeats every six weeks for {number} occurrences,<br/>starting on {start} ending on {end}',
    'six-weeks-neverending': 'Repeats every six weeks,<br/>starting on {start}, never ends',
    'monthly': 'Repeats every month for {number} occurrences,<br/>starting on {start} ending on {end}',
    'monthly-neverending': 'Repeats every month,<br/>starting on {start}, never ends',
    'custom': 'Repeats for {number} occurrences,<br/>starting on {start} ending on {end}',
    'group': 'Group Booking<br /><strong>{count} person<strong> | Group Booking<br /><strong>{count} people<strong>',
  },
  'part-of-series': 'This is part of a series that started {start} ending {end}',
  'part-of-series-neverending': 'This is part of a series that started {start}',
  labels: {
    'end-type': 'End Repeat',
    'repeat': 'Select repeat rule',
    'people': 'Number of people',
  },
  'bookings-empty-state': 'Select recurring rules to add appointments to your calendar.',
  'confirm-cancel': {
    'title': 'Delete recurring appointment?',
    'desc': 'This will remove all appointments associated with this series from your calendar.',
    'confirm': 'Delete recurring',
  },
  'hints': {
    'group-size': 'Select the number of people you want to book for. You won’t be able to add more appointments to the group booking later on but you can modify each appointment\'s details individually.',
  },
}
